module.exports = __webpack_public_path__ + "img/meeting.f7a7b867.jpg";